import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

export interface APIData {
  licencePeriods: LicencePeriod[];
  mediaUsages: MediaUsage[];
  territoryUsages: TerritoryUsage[];
  territoryCategories: [];
  mediaCategories: [];
  packs: Pack[];
}

export interface LicencePeriod {
  id: number;
  years: number;
  value: number;
}

export interface MediaUsage {
  id: number;
  title: string;
  description: string;
  type: string;
  value: number;
  selected?: boolean;
  disabled?: boolean;
}

export interface TerritoryUsage {
  id: number;
  title: string;
  description: string;
  countries: string[];
  type: string;
  value: number;
  selected?: boolean;
  disabled?: boolean;
}

export interface Pack {
  id: number;
  title: string;
  description: string;
  mediausages: [];
  territoryusages: [];
  licenceperiod: number;
}

@Injectable({
  providedIn: 'root'
})
export class ApiService {
  private dataURL: string = 'https://calcbe2026-production-ogpeg2.laravel.cloud/v2/data';
  constructor(private httpClient: HttpClient) { }
  fetch(): Observable<APIData>{
    return this.httpClient.get<APIData>(this.dataURL);
  }
}
